import { useState, useEffect, useCallback } from 'react';
import { useSearchMedia } from 'api/media/api';
import { CropRatio } from '../../Modals/CropImageModal';
import { ISearchMediaInput } from 'types/types';

export const useSearchMediaList = (mediaType: string | null, ratios?: CropRatio[]) => {
  const [searchParam, setSearchParam] = useState({
    currentPage: 1,
    query: JSON.stringify(
      ratios && ratios.length > 0
        ? {
            ratios: ratios,
          }
        : {},
    ),
  });

  const { searchMedia, data: displayList, loading } = useSearchMedia();

  useEffect(() => {
    const _query = JSON.parse(searchParam.query);
    if (ratios) {
      _query.ratios = ratios;
    }
    if (mediaType) {
      _query.type = mediaType;
    }
    setSearchParam({ ...searchParam, query: JSON.stringify(_query) });
  }, [mediaType, ratios]);

  const onSearchMedia = useCallback(() => {
    const _query = JSON.parse(searchParam.query);
    if (_query.type) {
      const searchMediaInput = {
        from: searchParam.currentPage,
        size: 20,
        query: searchParam.query,
        sort: 'createdTime',
      } as ISearchMediaInput;
      searchMedia({ variables: { input: searchMediaInput } });
    }
  }, [searchParam]);

  useEffect(() => {
    onSearchMedia();
  }, [searchParam]);

  return {
    loading,
    onSearchMedia,
    setSearchParam,
    searchParam,
    mediasData: displayList,
  };
};
